<fieldset>
  <legend class="keyLabel">Drive Package</legend>
  @if (response().PrimaryDrivePackage) {
    <div class="outputPanel">
      <app-schedule-line-drive-package [fieldLabel]="'Primary'"
        [response]="response().PrimaryDrivePackage">
      </app-schedule-line-drive-package>
    </div>
  }
  @if (response().SecondaryDrivePackage) {
    <div class="outputPanel">
      <app-schedule-line-drive-package [fieldLabel]="'Alternate'"
        [response]="response().SecondaryDrivePackage">
      </app-schedule-line-drive-package>
    </div>
  }
</fieldset>
